/* IMPORTANT */
// //////////////////////////////////////////////////////// //
// SPACE GATE - Permisson validator                         //
// Not use on any component in the BEFORECREATED statement  //
// Order ALPHABETICALLLY                                    //
// //////////////////////////////////////////////////////// //
export const sGate = {
  data () {
    return {
      xCompany: ''
    }
  },
  methods: {
    /**
     * ABRIR PUERTA
     * @param string   gate key word
     * @param object   gatekeys roles ej. {rt:false, ad:true, ag:true, cl:false}
     * @param array    gatelock enable permissons ej. [rt, ad, ag, cl]
     * @return boolean acceso
     * @author bgiron
     **/
    openGate (gate, gatekeys) {
      // return true
      if (gate !== '' && gatekeys != null) {
        if (gate === 'add-collaborator') {
          return this.vGateKey(gatekeys, ['rt', 'ad'])
        } else if (gate === 'del-collaborator') {
          return this.vGateKey(gatekeys, ['rt', 'ad'])
        } else if (gate === 'change-tikket-type') {
          return this.vGateKey(gatekeys, ['rt', 'ad'])
        } else if (gate === 'change-tikket-priority') {
          return this.vGateKey(gatekeys, ['rt', 'ad'])
        } else if (gate === 'set-time-delay') {
          return this.vGateKey(gatekeys, ['rt', 'ad'])
        }
      }
      return false
    },
    /**
     * VALIDA ACCESO
     * @param object   gatekeys roles ej. {rt:false, ad:true, ag:true, cl:false}
     * @param array    gatelock enable permissons ej. [rt, ad, ag, cl]
     * @return boolean acceso
     * @author bgiron
     **/
    vGateKey (gatekeys, gatelock) {
      // loop gatelocks
      for (var i = 0; i < gatelock.length; i++) {
        // if have the key
        if (gatekeys[gatelock[i]] != null && gatekeys[gatelock[i]] === true) {
          return true
        }
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/sGate.js